<template>
  <div class="vue-events-list">
    <div class="cp-filter-list">
      <tequila-custom-select
        v-if="filters.thematics && filters.thematics.length > 1"
        name="thematic-filter"
        :options="filters.thematics"
        :option-keys="['value', 'label']"
        @input="filterByThematic"
        :placeholder-option="false"
        :selected-value="selectedThematic"
        class="filter"
      />
      <tequila-custom-select
        v-if="filters.categories && filters.categories.length > 1"
        name="category-filter"
        :options="filters.categories"
        :option-keys="['value', 'label']"
        @input="filterByCategory"
        :placeholder-option="false"
        :selected-value="selectedCategory"
        class="filter"
      />
    </div>
    <div class="medias-list">
      <media-card
        v-for="(media, index) in items"
        :type-player="typePlayer"
        :display-vodalys="displayVodalys"
        :key="index"
        :media="media"
      />
    </div>
    <loading
      v-if="loading"
    />
    <button
      type="button"
      class="btn load-more"
      v-if="currentPage < maxPage && !loading"
      @click="loadNextPage"
    >
      {{ seeMoreLabel }}
    </button>
  </div>
</template>

<script>
import axios from 'axios';
import tequilaCustomSelect from 'teq-custom-select';
import MediaCard from './MediaCard';
import Loading from './Loading';

export default {
  components: {
    Loading,
    MediaCard,
    tequilaCustomSelect,
  },
  props: {
    ajaxUrl: {
      type: String,
      required: true,
    },
    displayVodalys: {
      type: String,
      required: true,
    },
    typePlayer: {
      type: String,
      required: true,
    },
    seeMoreLabel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      maxPage: 1,
      items: [],
      loading: true,
      selectedThematic: null,
      selectedCategory: null,
      filters: {},
    };
  },
  async created() {
    document.body.classList.add('page-mediacenter-list')
    await this.getPosts();
  },

  methods: {
    async getPosts(params = {}) {
      this.loading = true;
      this.completed = false;
      const start = Date.now();

      try {
        const { data } = await axios.get(this.ajaxUrl, this.params(params));
        this.filters = data.data.filters;
        this.currentPage = data.data.pagination.currentPage;
        this.items = [...this.items, ...data.data.list];
        this.maxPage = data.data.pagination.maxPage;
      } catch (error) {
        console.log(error);
      }

      this.completed = true;

      this.removeLoading(start);
    },

    params({ page }) {
      return {
        params: {
          page: page || this.currentPage,
          thematic: this.selectedThematic,
          category: this.selectedCategory,
          count: window.screen.width >= 560 ? 12 : 6,
        },
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };
    },

    async loadNextPage() {
      if (this.currentPage + 1 > this.maxPage) {
        return;
      }

      await this.getPosts({ page: this.currentPage + 1 });
    },

    async filterByThematic(thematic) {
      this.selectedThematic = thematic.value;
      this.resetPagination();
      this.items = [];
      await this.getPosts();
    },

    async filterByCategory(category) {
      this.selectedCategory = category.value;
      this.resetPagination();
      this.items = [];
      await this.getPosts();
    },

    resetPagination() {
      this.currentPage = 1;
    },

    removeLoading(start) {
      const diff = Math.floor((Date.now() - start) / 1000);
      const delay = diff <= 800 ? 800 : 0;

      setTimeout(() => {
        this.loading = false;
      }, delay);
    },
  },
};
</script>
